import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as getShopActions from "../../slices/manage/getShop.slice";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
export var getShop = function(payload, param) {
    var modalObj = param.modalObj, setModalObj = param.setModalObj;
    return function() {
        var _ref = _async_to_generator(function(dispatch) {
            var config, result, error, statusCode, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch(getShopActions.fetchData());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        config = {
                            method: "post",
                            url: endPoint.GET_SHOP,
                            data: payload
                        };
                        return [
                            4,
                            http(config)
                        ];
                    case 2:
                        result = _state.sent();
                        dispatch(getShopActions.fetchDataSuccess(result.data));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        statusCode = 500;
                        errorMessage = "เกิดข้อผิดพลาด";
                        if (http.isAxiosError(error) && error.response) {
                            statusCode = error.response.status;
                            errorMessage = error.response.data.message;
                        }
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส ".concat(statusCode),
                            navigateDirection: undefined,
                            title: errorMessage
                        }));
                        dispatch(getShopActions.fetchDataFailure());
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    }();
};
